// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vDRYFVhtRVPHCdZYfwPh{padding-top:var(--spacing-xxxxs);padding-bottom:var(--spacing-xxxxs)}`, "",{"version":3,"sources":["webpack://./src/components/navigation/navigation-panel/sub-navigation-panel/ui-components/navigation-divider/navigation-divider.scss"],"names":[],"mappings":"AAAA,sBACI,gCAAA,CACA,mCAAA","sourcesContent":[".navigationDivider {\n    padding-top: var(--spacing-xxxxs);\n    padding-bottom: var(--spacing-xxxxs);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationDivider": `vDRYFVhtRVPHCdZYfwPh`
};
export default ___CSS_LOADER_EXPORT___;
